import { BASE_PATH, LANG } from 'containers/App/constants'

export const SITE_MAP__CACHE_TIME = 1000 * 60 * 60 * 24 // 1d
export const SITE_MAP_URL = `${BASE_PATH}/content/${LANG}/site-map`
